import Form from "../../components/abstract/Form"; // Change to new form later
import { triggerReset } from "../../ApiClient";
import {useState} from "react"
import { Button, Typography } from "@mui/material";

export default function TriggerReset() {
    const [state, setState] = useState<'form'|'sent'>('form')
    const [password, setPassword] = useState<string>('')

    // adding a password field fixes issue of many entries in stateList
    // issue of stateList only exists when there is one input field as of right now
    const inputs = [{key: "netid", name:"Netid"}]
    if (state === "form") {
        return (
            <Form
                header="Password Reset Request"
                inputs={inputs}
                apiCall={triggerReset}
                handleSuccess={() => {setState('sent')}}
                specialInputs={[]}
                buttonContained
                />
        )
    }
    else {
        return(
        <>
            <Typography variant='h3' mb={3} textAlign={"center"}>
                An email with the instructions for resetting your password has been sent to the email
                associated with your account
            </Typography>
            <Button size='medium' onClick={() => {setState('form')}}>
                <Typography>Resend email</Typography>
            </Button>
        </>
        )
    }
}
